<template>
  <div class="home">
    <h1 class="text-3xl">This Week</h1>
    <!-- IDEA - ADD PROGRESS BAR SHOWING TIME REMAINING -->
    <div>
      {{ dateRange }}
    </div>

    <div class="py-3 flex flex-col justify-center">
      <!-- TODO - SET MAX NUMBER OF DISPLAYED -->
      <!-- TODO - TURN INTO LINKS -->
      <!-- TODO - ADD NEW BUTTON -->
      <!-- TODO - ADD HOVER BEHAVIOR -->
      <div class="flex justify-center">
        <template v-if="advisors.length">
          <!-- TODO - ADD SOMETHING WITH A CLICK HERE -->
          <avatar
            v-for="advisor in advisors"
            :key="advisor.id"
            :name="advisor.name"
            class="-m-1 cursor-default"
          />
        </template>
        <div v-else>
          <!-- TODO - IMPLEMENT ME WITH DIRECT MODAL -->
          <router-link
            to="/advisors"
            tag="button"
            class="inline-flex items-center px-2 py-2 border border-transparent text-sm leading-3 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition ease-in-out duration-150"
          >
            Add New Advisor
          </router-link>
        </div>
      </div>
    </div>

    <!-- TODO - BUTTONS TO MARK AS COMPLETE OR MOVE TO NEXT WEEK -->
    <!-- TODO - GROW THIS TO SIZE AS THE PERSON TYPES OR LIMIT GOAL LENGTH -->
    <div class="my-6">
      <label class="block text-left">
        <span class="text-gray-700 font-bold text-sm">Goals</span>
        <p class="text-xs text-gray-500">
          Are these actually moving the needle?
        </p>
      </label>
      <goal-list :goals="goals" :weekId="weekId" class="my-2" />
    </div>

    <div class="my-6">
      <label class="block text-left">
        <span class="text-gray-700 font-bold text-sm">Update</span>
        <p class="text-xs text-gray-500">
          The best updates are short, sweet, and to the point.
        </p>
        <textarea
          id="update"
          v-model="summary"
          @keyup="debouncedSaveSummary"
          @blur="debouncedSaveSummary.flush"
          rows="3"
          class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
        >
        </textarea>
      </label>
    </div>

    <div class="my-6">
      <label class="block text-left">
        <span class="text-gray-700 font-bold text-sm">Question</span>
        <p class="text-xs text-gray-500">
          What's something you'd like feedback on from your Advisors?
        </p>
        <input
          type="text"
          id="question"
          autocomplete="off"
          v-model="question"
          @keyup="debouncedSaveQuestion"
          @blur="debouncedSaveQuestion.flush"
          class="form-input mt-4 block w-full text-sm"
          placeholder="What's something you'd like feedback on from your Advisors?"
        />
      </label>
    </div>

    <h1 class="text-3xl pt-4">Next Week</h1>
    <!-- IDEA - ADD PROGRESS BAR SHOWING TIME REMAINING -->
    <div>
      {{ nextDateRange }}
    </div>

    <div class="mb-6">
      <label class="block text-left">
        <span class="text-gray-700 font-bold text-sm">Goals</span>
        <p class="text-xs text-gray-500">
          What are the biggest actions you can take this week to make the most
          progress?
        </p>
      </label>
      <goal-list :goals="nextGoals" :weekId="nextWeekId" class="my-2" />
    </div>

    <!-- TODO - DECIDE ON TIMING - 8am? 10am? -->
    <!-- TODO - PIVOT BASED ON THIS/LAST WEEK - EX SUNDAY MORNING -->
    <div class="my-12">
      Your update will be sent in {{ timeToNextUpdate }} on Sunday at 8am
      Pacific.
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import debounce from "lodash/debounce";

import utils from "@/utils";

import Avatar from "@/components/Avatar";
import GoalList from "@/components/GoalList";

export default {
  name: "Home",
  components: {
    Avatar,
    GoalList,
  },
  data() {
    return {
      // TODO - HANDLE THIS IN THE STORE GLOBALLY?
      now: new Date(),
      nowInterval: undefined,
      summary: "",
      question: "",
      goals: [],
      nextGoals: [],
      weekId: utils.getWeekId(),
      nextWeekId: utils.getNextWeekId(),
      debouncedSaveSummary: undefined,
      debouncedSaveQuestion: undefined,
    };
  },
  computed: {
    advisors() {
      return this.$store.state.advisors.advisors.filter(
        (advisor) => advisor.status === "ACCEPTED"
      );
    },
    dateRange() {
      const start = dayjs().startOf("week");
      const end = dayjs().endOf("week");
      return start.format("MMMM D") + " - " + end.format("MMMM D");
    },
    nextDateRange() {
      const start = dayjs().startOf("week").add(1, "week");
      const end = dayjs().endOf("week").add(1, "week");
      return start.format("MMMM D") + " - " + end.format("MMMM D");
    },
    timeToNextUpdate() {
      const update = dayjs().day(0).add(1, "week").hour(8);
      const hours = update.diff(this.now, "hour");
      if (hours > 0) {
        return `${hours} hours`;
      }

      return `${update.diff(this.now, "minute")} minutes`;
    },
    // TODO - SOMETHING MORE ELEGANT
    firebaseUpdate() {
      return this.$store.state.updates;
    },
    initialized() {
      return this.$store.state.updates.initialized;
    },
  },
  methods: {
    saveSummary() {
      this.$store.dispatch("updates/setSummary", this.summary);
    },
    saveQuestion() {
      this.$store.dispatch("updates/setQuestion", this.question);
    },
    flushDebouncedSaves() {
      this.debouncedSaveSummary.flush();
      this.debouncedSaveQuestion.flush();
    },
  },
  watch: {
    // FIXME - GROSS
    firebaseUpdate: {
      handler(newVal) {
        this.summary = newVal.update.summary || "";
        this.question = newVal.update.question || "";
        this.goals = newVal.goals;
        this.nextGoals = newVal.nextGoals;
      },
      deep: true,
    },
  },
  created() {
    // FIXME - SHOULD THIS ACTUALLY BE AFTER AUTH?
    // FIXME - GLOBAL TIME IN STORE?
    this.$store.dispatch("updates/loadAndListen");
    this.nowInterval = setInterval(() => {
      const now = new Date();
      // Sunday - update when we let users define their own update days
      // TODO - SOMETHING MORE ELEGANT ONCE THE USAGE DEMANDS IT
      if (now.getDay() === 6 && this.now.getDay() !== 6) {
        // It's Sunday, time to reload!
        window.location.reload();
      }
      this.now = new Date();
    }, 1000 * 60);

    // Debounce Magic - potentially include maxWait in the future
    this.debouncedSaveSummary = debounce(this.saveSummary, 1000);
    this.debouncedSaveQuestion = debounce(this.saveQuestion, 1000);
    window.addEventListener("beforeunload", this.flushDebouncedSaves);
  },
  beforeDestroy() {
    this.flushDebouncedSaves();
    window.removeEventListener("beforeunload", this.flushDebouncedSaves);
    clearInterval(this.nowInterval);
  },
};
</script>
